// extracted by mini-css-extract-plugin
export default {"available-link-list":"styles_available-link-list__iRrUC","available-link-item":"styles_available-link-item__OCo2C","active":"styles_active__xPr88"};